import { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from 'elem/compCommon/EFPicture';
import YoutubePlay from '@elem/SVGIcon/OutdoorRecreation/YoutubePlay';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideoModal from '@/components/UI/EFVideoModal';

export default function P() {
    const { useLang, useState, useEffect, useRouter } = useGlobal();
    const { t } = useLang('offgrid');
    const { locale } = useRouter();
    const [source, setSource] = useState('');
    const [gap, setGap] = useState(24);
    const LOCAL_SITES: string[] = ['de', 'za', 'fr'];
    const cards: any = [
        {
            img: '/responsive/picture/off-grid/8_1',
            text: t('secP_list1'),
            video: (() => {
                const map: any = {
                    us: 'https://www.youtube.com/embed/wPUbRhucRnA?si=hShU52xLsWgDy_mn',
                    // de: 'https://www.youtube.com/embed/BljtM9_XTs4?si=qip5mfIvNfVaQwbg',
                    // za: 'https://www.youtube.com/embed/xLcCU29riWE?si=za-NI7Ghpi12c87Z',
                    // fr: 'https://www.youtube.com/embed/jvtgKyf0peY?si=0PGuiNljObyzV5sT',
                };
                return map[locale] || map.us;
            })(),
        },
        {
            img: '/responsive/picture/off-grid/8_2',
            text: t('secP_list2'),
            video: (() => {
                const map: any = {
                    us: 'https://www.youtube.com/embed/clYWjW9IyWE?si=rlh9GD6Ug5dZD4Pv',
                    // de: 'https://www.youtube.com/embed/r4VF3jWhdss?si=2lqTEkl-TxDMxABM',
                    // za: 'https://www.youtube.com/embed/cLUIyKrd9ts?si=C8VPQT-30jqwfYZk',
                    // fr: 'https://www.youtube.com/embed/f-OCUmzlJ2M?si=cl-zwcaIbcTs_G80',
                };
                return map[locale] || map.us;
            })(),
        },
        {
            img: '/responsive/picture/off-grid/8_3',
            text: t('secP_list3'),
            video: (() => {
                const map: any = {
                    us: 'https://www.youtube.com/embed/274ZvZ7PWZc?si=mff64jb2c4uhjfH6',
                    // de: 'https://www.youtube.com/embed/XtN6-CLbzt8?si=rld25Okx-R5_40-x',
                    // za: 'https://www.youtube.com/embed/ULol9L_07_E?si=qi0WrQYGkVytYIKX',
                    // fr: 'https://www.youtube.com/embed/NwA31h4QAvM?si=RxXm_MwT_ZmAhIaT',
                };
                return map[locale] || map.us;
            })(),
        },
        {
            img: '/responsive/picture/off-grid/8_4',
            text: t('secP_list4'),
            video: (() => {
                const map: any = {
                    us: 'https://www.youtube.com/embed/vtEIeSJ8UWY?si=7JmpxxzWmdYmezxA',
                    // de: 'https://www.youtube.com/embed/1SpIn7D11nI?si=VNxyMOfH3bJKn3l1',
                    // za: 'https://www.youtube.com/embed/a2npZ_toi7U?si=ox5od9JlDnPJwiaK',
                    // fr: 'https://www.youtube.com/embed/PzczrIeflPs?si=7xIuWKtJlNZJizlK',
                };
                return map[locale] || map.us;
            })(),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
            window.addEventListener('resize', resetGap);
            return () => window.removeEventListener('resize', resetGap);
        }
    }, []);

    return (
        <div id="off-grid-P" className={`off-grid-P off-grid-box ${css['off-grid-P']}`}>
            <div className="text-info">
                <h2 className="title">{t('secP_title')}</h2>
            </div>
            <Swiper
                className="swiper-box"
                modules={[Scrollbar]}
                spaceBetween={gap}
                // centeredSlides={true}
                slidesPerView={'auto'}
                initialSlide={0}
                scrollbar={{
                    hide: false,
                    draggable: true,
                    dragSize: 32,
                    snapOnRelease: true,
                }}
            >
                {cards?.map((card: any, k: number) => (
                    <SwiperSlide className={`swiper-item item-${k + 1}`} key={k} onClick={() => setSource(card?.video)}>
                        <EFPicture src={`${card?.img}${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.jpg`} alt={card?.text} />
                        <YoutubePlay className="youtube-icon" />
                        <div className="card-text-box">
                            <p className="card-text">{card?.text}</p>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            {Object.keys(source)?.length > 0 && (
                <EFVideoModal visible={Boolean(source)} source={source} onClose={() => setSource('')} playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'} />
            )}
        </div>
    );
}
